export default {
    data() {
        return {
            client: null,
        }
    },
    methods: {
        async getClientData() {
            this.clientDataLoading = true
            const {data: {client, message, errors}, status} = await this.$http.get('/api/v1/clients/get-client', {}).catch(e => e)
            if (this.$error(status, message, errors)) return
            this.client = client
        }
    }
}